module.exports = __webpack_public_path__ + "img/clipboard-import.5cd49e54.svg";